import { Layers, MessagesSquare, Shield, BarChart3, Percent, Camera } from "lucide-react";
import { motion } from "motion/react";
import { SERVICES } from "../data/services";

const ICONS = {
  layers: Layers,
  messages: MessagesSquare,
  shield: Shield,
  chart: BarChart3,
  percent: Percent,
};

// Kartalar ketma-ket ko'tariladi. Harakat o'ramda: tugmadagi CSS `transition`
// har kadrdagi `transform` ni ham silliqlab, harakatni sekinlashtirardi
const card = (i) => ({
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.55, delay: 0.32 + i * 0.07, ease: [0.16, 1, 0.3, 1] },
});

/** Yo'nalish kartalari — tizim nima qila olishini bir qarashda ko'rsatadi. */
export function ServiceCards({ mode, onSelect, onPhoto }) {
  return (
    <div className="space-y-2.5">
      <div className="grid gap-2.5 sm:grid-cols-2">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon] ?? Layers;
          const active = mode === s.id;

          return (
            <motion.div key={s.id} {...card(i)}>
            <button
              onClick={() => onSelect(s.id)}
              className={`group h-full w-full rounded-2xl border p-3.5 text-left transition-all ${
                active
                  ? "border-sky-400/70 bg-sky-950/70 shadow-lg shadow-sky-950/50"
                  : "border-sky-800/40 bg-[#061c3b]/60 hover:border-sky-600/60 hover:bg-[#072147]/70"
              }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`shrink-0 rounded-xl border p-2 transition-colors ${
                    active
                      ? "border-sky-400/50 bg-sky-500/20 text-sky-300"
                      : "border-sky-800/50 bg-sky-950/60 text-sky-400/70 group-hover:text-sky-300"
                  }`}
                >
                  <Icon className="h-4 w-4" />
                </div>

                <div className="flex min-w-0 items-center gap-1.5">
                  <span className="text-sm font-semibold text-white">{s.title}</span>
                  {active && (
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-400" />
                  )}
                </div>
              </div>
            </button>
            </motion.div>
          );
        })}
      </div>

      {/* Rejim emas — pastdagi foto menyusini ochadi */}
      <motion.div {...card(SERVICES.length)}>
      <button
        onClick={onPhoto}
        className="group flex w-full items-center gap-3 rounded-2xl border border-sky-800/40 bg-[#061c3b]/60 p-3.5 text-left transition-all hover:border-sky-600/60 hover:bg-[#072147]/70"
      >
        <div className="shrink-0 rounded-xl border border-sky-800/50 bg-sky-950/60 p-2 text-sky-400/70 group-hover:text-sky-300">
          <Camera className="h-4 w-4" />
        </div>
        <span className="text-sm font-semibold text-white">Tovarni foto orqali tahlil qilish</span>
      </button>
      </motion.div>
    </div>
  );
}
